import * as React from 'react';
import { SiteInfo } from '../../hooks/useSiteInfo';
import { Link } from 'react-router-dom';
import SiteInfoClass from './SiteInfo';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import * as i18next from 'i18next';
import { isRecentlyUpdated } from '../../constants/recentlyUpdated';

interface IProps {
    site: SiteInfo;
    searchQuery: string;
    clearSearchQuery: () => void;
}

type Props = IProps;

class Site extends React.Component<Props, {}>{
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <Paper
                elevation={0}
                className="site"
                sx={{
                    position: 'relative',
                    mb: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    p: 1.5,
                    cursor: 'pointer',
                    transition: 'border-color 0.15s, box-shadow 0.15s',
                    '&:hover': {
                        borderColor: 'primary.main',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                    }
                }}
            >
                {isRecentlyUpdated(this.props.site.updateDateUTC) && (
                    <Chip
                        size="small"
                        label={i18next.t('site.recentlyUpdated')}
                        data-testid="recently-updated"
                        color="warning"
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            height: 18,
                            fontWeight: 600,
                            '& .MuiChip-label': { px: 0.75, fontSize: '0.65rem' }
                        }}
                    />
                )}
                <Link
                    onClick={() => this.props.clearSearchQuery()}
                    to={'/s/' + this.props.site.uniqueSiteId}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                >
                    <SiteInfoClass
                        key={this.props.site.uniqueSiteId + this.props.site.siteName}
                        site={this.props.site}
                        searchQuery={this.props.searchQuery}
                        fromAdmin={false}
                        includeState={true}
                    />
                </Link>
            </Paper>
        );
    }
}

export default Site;
